
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.142 6.222l-.104-.017h.001l-.014-.002-.03-.004-.282-.032a6.329 6.329 0 00-.617-.028l-.01-.001a6.265 6.265 0 106.09 7.888.928.928 0 011.792.48 8.122 8.122 0 01-9.947 5.743c-.083-.022-.083-.022-.165-.046A8.122 8.122 0 0113.244 4.36l.037.005.12.018.12.02.186.035.062.013a8.09 8.09 0 011.736.567l.71-1.246c.215-.38.765-.404.973-.044l2.65 4.59c.208.36-.088.825-.524.822l-5.243-.033a.513.513 0 01-.45-.778l.961-1.69a6.225 6.225 0 00-.837-.286l-.209-.052-.209-.045a6.308 6.308 0 00-.148-.027l.112.019-.136-.024-.097-.016.084.014z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    